import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { translate as t } from 'common/utils/translate';
import appUrls from 'base/app/urls';
import { Container, Wrapper, TopBar } from 'common/components';
import { DetailsSwitch } from 'templates/details';
import {
  ContentProvider,
  ContentList,
  FiltersForm,
  Sort,
  StatusFilter,
  SearchInput,
} from 'templates/content';
import { useMinisList } from '../queries';
import MinisDetails from './MinisDetails';

const fields = {
  search: 'search',
  filter: 'filter',
  sort: 'sort',
};

const MinisList = () => {
  const location = useLocation();
  const { data, isError } = useMinisList();
  const context = {
    data: data?.values,
    path: {
      details: appUrls.MINIS.DETAILS,
      list: appUrls.MINIS.LIST,
    },
  };

  return (
    <Container>
      <ContentProvider {...context}>
        <TopBar title={t("Mini's")}>
          <FiltersForm
            sort={['title', fields.sort]}
            search={['title', fields.search]}
            filter={['status', fields.filter]}
          >
            <Wrapper margin={[0, 0.5]}>
              <SearchInput name={fields.search} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <StatusFilter name={fields.filter} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <Sort name={fields.sort} />
            </Wrapper>
          </FiltersForm>
        </TopBar>
        <ContentList isError={isError} />
        <DetailsSwitch>
          <MinisDetails key={location.pathname} />
        </DetailsSwitch>
      </ContentProvider>
    </Container>
  );
};

export default MinisList;
